import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const BookIcon = (props: IconProps) => (
  <IconBox {...props}>
    <defs />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M0 5.90909C0 4.30244 1.30244 3 2.90909 3H20.3636c3.8577 0 7.5574 1.53246 10.2852 4.26026 2.7278 2.72781 4.2603 6.42754 4.2603 10.28524v40.7272c0 1.6067-1.3025 2.9091-2.9091 2.9091s-2.9091-1.3024-2.9091-2.9091c0-1.5431-.613-3.0229-1.7041-4.114-1.0911-1.0912-2.571-1.7042-4.1141-1.7042H2.90909C1.30244 52.4545 0 51.1521 0 49.5455V5.90909zM29.0909 48.1953V17.5455c0-2.3147-.9195-4.5345-2.5561-6.1712-1.6367-1.63664-3.8565-2.55612-6.1712-2.55612H5.81818V46.6364H23.2727c2.0603 0 4.0643.5464 5.8182 1.5589z"
    />
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M33.3512 7.26026C36.079 4.53246 39.7787 3 43.6364 3h17.4545C62.6976 3 64 4.30244 64 5.90909V49.5455c0 1.6066-1.3024 2.909-2.9091 2.909H40.7273c-1.5431 0-3.023.613-4.1141 1.7042a5.81801 5.81801 0 00-1.7041 4.114c0 1.6067-1.3025 2.9091-2.9091 2.9091s-2.9091-1.3024-2.9091-2.9091V17.5455c0-3.8577 1.5325-7.55743 4.2603-10.28524zm1.5579 40.93504c1.7539-1.0125 3.7579-1.5589 5.8182-1.5589h17.4545V8.81818H43.6364c-2.3147 0-4.5345.91948-6.1712 2.55612-1.6366 1.6367-2.5561 3.8565-2.5561 6.1712v30.6498z"
    />
  </IconBox>
);

export default BookIcon;
